import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="ast-placeholder text-center">
      <h2 className="serif">Page not found</h2>
      <p className="sans-serif text-muted">The page you're looking for doesn't exist.</p>
      <Link className="btn btn-ast-blue function-button sans-serif" to="/">
        Back to Home
      </Link>
    </div>
  );
}
